'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENTS = exports.EVENTS = {
  click: 'report',
  mousemove: true,
  mousedown: 'report',
  touchmove: true,
  touchstart: 'report',
  keydown: true,
  change: false,
  scroll: true,
  wheel: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-locky/dist/defaultEvents.js
// module id = 204
// module chunks = 0